import { defineComponent as _defineComponent } from 'vue'
import { Beneficiary, beneficiaryName } from 'ah-api-gateways';
import { BModal, BvModalEvent } from 'bootstrap-vue';
import BeneficiaryEditor from './BeneficiaryEditor.vue';
import RouteProtectorModal from 'ah-common-lib/src/common/components/route/RouteProtectorModal.vue';
import { computed, reactive, ref } from 'vue';
import { FormValidation } from 'ah-common-lib/src/form/interfaces';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'BeneficiaryEditModal',
  props: {
    beneficiary: null
  },
  emits: ["update:beneficiary"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:beneficiary', value: Beneficiary): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  beneficiary?: Beneficiary;
};

const beneficiaryFormModal = ref<InstanceType<typeof BModal> | null>(null);

const oboModal = ref<InstanceType<typeof BModal> | null>(null);

const protectorModal = ref<InstanceType<typeof RouteProtectorModal> | null>(null);

const onBehalfOfClient = useOnBehalfOf();





const state = reactive({
  validations: [] as FormValidation[],
  beneficiaryName: '' as string,
});

const formTitle = computed(() => {
  return props.beneficiary ? 'Edit Beneficiary' : 'Add Beneficiary';
});

const clientName = computed(() => {
  if (onBehalfOfClient.value) {
    return onBehalfOfClient.value.name;
  }
  return '';
});

function onHide(event: BvModalEvent) {
  if (event.trigger && anyDirty.value) {
    event.preventDefault();
    protectorModal.value!.$refs.modal.show();
  }
}

const anyDirty = computed(() => {
  return !!state.validations.find((f) => !f || f.$anyDirty);
});

function showModal() {
  beneficiaryFormModal.value!.show();
}

function showOBOModal() {
  oboModal.value!.show();
}

function hideModal() {
  state.validations = [];
  beneficiaryFormModal.value!.hide();
}

function hide() {
  beneficiaryFormModal.value!.hide();
}

function onBeneficiarySaved(beneficiary: Beneficiary) {
  hideModal();

  state.beneficiaryName = beneficiaryName(beneficiary) || '';

  if (onBehalfOfClient.value) {
    showOBOModal();
  }

  // setTimeout is used to ensure reactions happens after the validations have been cleared and route protector is off
  setTimeout(() => {
    emit('update:beneficiary', beneficiary);
  });
}

return { __sfc: true,beneficiaryFormModal, oboModal, protectorModal, onBehalfOfClient, emit, props, state, formTitle, clientName, onHide, anyDirty, showModal, showOBOModal, hideModal, hide, onBeneficiarySaved, beneficiaryName, BModal, BeneficiaryEditor, RouteProtectorModal }
}

})